import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

interface AnimatedCounterProps {
  value: number;
  className?: string;
}

/**
 * Renders a number that animates from 0 to the target value using spring physics.
 * @param value - The target number to count up to
 * @param className - Optional CSS class name for the rendered span
 * @returns An animated span that counts up to the given value on mount
 */
export default function AnimatedCounter({
  value,
  className,
}: AnimatedCounterProps) {
  const motionValue = useMotionValue(0);
  const spring = useSpring(motionValue, { damping: 30, stiffness: 200 });
  const display = useTransform(spring, (v) => Math.round(v).toLocaleString());

  useEffect(() => {
    motionValue.set(value);
  }, [value, motionValue]);

  return <motion.span className={className}>{display}</motion.span>;
}
